import React, { useState } from "react";
import { Button, Modal, Dropdown, Grid, Form } from "semantic-ui-react";
import { RootState } from "../model";
import { connect } from "react-redux";

const initialState: any = {
    userSetup: {} as any,
    practices: [],
    practiceOpts: []
}

function DefaultPracticeModal(props: any) {

    const [state, setStates] = useState(initialState);

    const onSelectChange = (data: any) => {
        setStates({ ...state, practices: data.value });
    }

    return (
        <>
            <Modal className={'modalCenter'} onClose={() => props.handleClose()} open={true}>
                <Modal.Header content='Default Practice' />
                <Modal.Content>
                    <Form className="formStyle mt10">
                        <Grid>
                            <Grid.Row>
                                <Grid.Column>
                                    <label className="mr10">Select Default Practice</label>
                                    <Dropdown
                                        search={true}
                                        className='mr10'
                                        fluid={true}
                                        placeholder='Select Practice'
                                        selection={true}
                                        multiple={true}
                                        options={state.practiceOpts || []}
                                        onChange={(_event, data) => onSelectChange(data)}
                                        value={state.practices}
                                    />
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Form>
                </Modal.Content>
                <Modal.Actions>
                    <Button
                        content="OK"
                        primary={true}
                        disabled={!state.practices.toString()}
                        onClick={() => {

                        }}
                    />
                    <Button
                        content="RESET"
                        secondary={true}
                        disabled= { state.userSetup == undefined }
                       // onClick={() => { resetUserSetup() }}
                    />
                </Modal.Actions>
            </Modal>

        </>
    );
}

function mapStateToProps(state: RootState) {
    return {
        practice: state.practice
    };
}

export default connect(mapStateToProps)(DefaultPracticeModal);
